import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "ONovoMembro",
  "data-testid": "ONovoMembro"
}
const _hoisted_2 = { class: "ONovoMembro__Conteudo" }

import { ref, computed, watch } from "vue"
  import { OTabelaMembrosProjeto, OSelecionarMembrosProjeto } from "@/components/Projetos"
  import { ODadosNaoEncontrados } from "@/components/Gerais"
  import { MembroDoProjeto } from "@/repositorios/projeto/projeto.modelo"
  import { ListarProfissionais } from "@/repositorios/profissional/profissional.modelo"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { useI18n } from "vue-i18n"

  interface Props {
    membrosSelecionados: MembroDoProjeto[]
    adicionandoMembros: boolean
    abrirTabelaDeAdicaoDeMembros: () => void
    fecharTabelaDeAdicaoDeMembros: () => void
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ONovoMembro',
  props: {
    membrosSelecionados: null,
    adicionandoMembros: { type: Boolean },
    abrirTabelaDeAdicaoDeMembros: null,
    fecharTabelaDeAdicaoDeMembros: null
  },
  emits: ["update:membrosSelecionados"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (
      event: "update:membrosSelecionados",
      membrosSelecionados: MembroDoProjeto[]
    ): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    membrosSelecionados: MembroDoProjeto[]
    adicionandoMembros: boolean
    abrirTabelaDeAdicaoDeMembros: () => void
    fecharTabelaDeAdicaoDeMembros: () => void
  }

  
  

  const { t } = useI18n()

  const { agruparValoresDe } = usarManipuladorObjetos()
  const profissionaisSelecionados = ref<ListarProfissionais[]>([])
  const membrosParaAdicionar = ref<MembroDoProjeto[]>([])
  const membrosParaRemover = ref<MembroDoProjeto[]>([])
  const membrosPreSelecionados = ref<string[]>([])

  const emitirMembros = computed({
    get(): MembroDoProjeto[] {
      return props.membrosSelecionados
    },
    set(membros: MembroDoProjeto[]) {
      emitir("update:membrosSelecionados", membros)
    },
  })

  const naoPossuemMembros = computed(() => {
    return props.membrosSelecionados.length === 0
  })

  const atualizarCodigoDoMembro = (dadosDoMembro: {
    novoValor: string
    valorAntigo: string
    idUsuario: string
  }): void => {
    emitirMembros.value = emitirMembros.value.map((membro) => {
      const mesmoCodigoAntigo = membro.codigo === dadosDoMembro.valorAntigo
      const mesmoIdUsuario = membro.idUsuario === dadosDoMembro.idUsuario

      if (mesmoCodigoAntigo && mesmoIdUsuario) {
        membro.codigo = dadosDoMembro.novoValor
      }

      return membro
    })
  }

  const adicionarMembro = (novoMembro: MembroDoProjeto): void => {
    membrosParaRemover.value = membrosParaRemover.value.filter(
      (membro) => membro.idUsuario !== novoMembro.idUsuario
    )
    membrosParaAdicionar.value.push(novoMembro)
  }

  const removerMembro = (membroParaRemover: MembroDoProjeto): void => {
    membrosParaAdicionar.value = membrosParaAdicionar.value.filter(
      (membro) => membro.idUsuario !== membroParaRemover.idUsuario
    )
    membrosParaRemover.value.push(membroParaRemover)
  }

  const confirmarEnvioDosMembrosSelecionados = (): void => {
    if (membrosParaAdicionar.value) {
      emitirMembros.value.push(...membrosParaAdicionar.value)
    }

    if (membrosParaRemover.value) {
      const idsMembroParaRemover = agruparValoresDe<MembroDoProjeto, string>(
        membrosParaRemover.value,
        "idUsuario"
      )

      emitirMembros.value = emitirMembros.value.filter((membro) => {
        return !idsMembroParaRemover.includes(membro.idUsuario)
      })
    }

    resetarTabelaDeAdicaoDeMembros()
  }
  const cancelarAdicaoDeMembros = (): void => {
    resetarTabelaDeAdicaoDeMembros()
  }

  const resetarTabelaDeAdicaoDeMembros = (): void => {
    membrosParaAdicionar.value = []
    membrosParaRemover.value = []
    props.fecharTabelaDeAdicaoDeMembros()
  }

  watch(
    () => props.adicionandoMembros,
    () => {
      membrosPreSelecionados.value = agruparValoresDe<MembroDoProjeto, string>(
        props.membrosSelecionados,
        "idUsuario"
      )
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      (__props.adicionandoMembros)
        ? (_openBlock(), _createBlock(_unref(OSelecionarMembrosProjeto), {
            key: 0,
            "profissionais-pre-selecionados": membrosPreSelecionados.value,
            "onUpdate:profissionais-pre-selecionados": _cache[0] || (_cache[0] = ($event: any) => ((membrosPreSelecionados).value = $event)),
            "profissionais-selecionados": profissionaisSelecionados.value,
            "onUpdate:profissionais-selecionados": _cache[1] || (_cache[1] = ($event: any) => ((profissionaisSelecionados).value = $event)),
            onAdicionarMembro: adicionarMembro,
            onEnviarMembrosSelecionados: confirmarEnvioDosMembrosSelecionados,
            onOnFecharTabelaDeAdicaoDeMembros: cancelarAdicaoDeMembros,
            onRemoverMembro: removerMembro,
            "data-testid": "ONovoMembro__TabelaDeAdicaoDeMembros"
          }, null, 8, ["profissionais-pre-selecionados", "profissionais-selecionados"]))
        : (_unref(naoPossuemMembros))
          ? (_openBlock(), _createBlock(_unref(ODadosNaoEncontrados), {
              key: 1,
              onOnAcao: __props.abrirTabelaDeAdicaoDeMembros,
              class: "ONovoMembro__NovoMembro",
              "data-test-id": "ONovoMembro__AdicionarDeEstadoVazio",
              "icone-avatar": "pi-user",
              mensagem: _unref(t)('naoHaNenhumMembro'),
              "texto-botao": _unref(t)('adicionarMembro')
            }, null, 8, ["onOnAcao", "mensagem", "texto-botao"]))
          : (_openBlock(), _createBlock(_unref(OTabelaMembrosProjeto), {
              key: 2,
              onAtualizarCodigo: atualizarCodigoDoMembro,
              "data-testid": "ONovoMembro__TabelaDeMembros",
              "membros-selecionados": __props.membrosSelecionados
            }, null, 8, ["membros-selecionados"]))
    ])
  ]))
}
}

})